$(function () {
    var $radios = $('[js-club-radio]')
    $radios.on({
        'mousedown': function (e) {
            var $radio = $(this);
            $radio.data('is-checked', $radio.find('input').prop('checked'));
        },
        'click': function (e) {
            var $radio = $(this);
            var $input = $radio.find('input');

            if ($radio.data('is-checked')) {
                e.preventDefault();
                $input.prop('checked', false);
                $input.trigger('change');
            }
        }
    });
});
